import TransferTaskCard from "components/TransferTaskCard";
import { handleLoading, useLoading } from "context/LoadingContext";
import getEsriDataFromLayer from "context/contextFunctions/getEsriDataFromLayer";
import { useMap } from "context/mapContext";
import api from "api";
import React, { useEffect } from "react";
import { Form } from "react-bootstrap";
import { useForm, useWatch } from "react-hook-form";
import { NotificationManager } from "react-notifications";

const neededDomains = ["Type"];

export default function HandoverReports() {
  const { register, getValues, control } = useForm({
    defaultValues: { Type: "Hand_Over" },
  });
  const [map, dispatchMap] = useMap();
  const [, dispatchLoading] = useLoading();
  const {
    view,
    transferReportTable,
    transferReportDomains,
    transferReportList,
  } = map;

  const watchChange = useWatch({ control, name: "Type" });

  useEffect(() => {
    (async () => {
      handleLoading(dispatchLoading, true);
      try {
        const token = localStorage.getItem("token");
        const query = `Type = '${getValues("Type")}'`;
        if (transferReportTable && view && token) {
          const orderByFields = ["Request_Date DESC"];
          const { res: transferReportRes, domains: tempTransferReportDomains } =
            await getEsriDataFromLayer({
              featureLayer: transferReportTable,
              orderByFields,
              view,
              neededDomains,
              query,
              returnDistinctValues: true,
              outFields: "Task_ID, Request_Date",
            });

          dispatchMap({
            type: "INIT",
            payload: {
              transferReportList: transferReportRes,
              transferReportDomains: tempTransferReportDomains,
            },
          });
        }
      } catch (error) {
        console.log(error);
      }
      handleLoading(dispatchLoading, false);
    })();
  }, [view, transferReportTable, watchChange]);

  const handleReports = async (transferReport) => {
    handleLoading(dispatchLoading, true);
    if (transferReport) {
      try {
        // TRANSFER TASK REPORT

        const reportsRes = await api.post(
          "reports/transfer",
          {
            taskId: transferReport.Task_ID,
          },
          {
            responseType: "arraybuffer",
            headers: {
              "Content-Type": "application/json",
              Accept: "application/pdf",
            },
          }
        );

        const url = window.URL.createObjectURL(new Blob([reportsRes.data]));
        const link = document.createElement("a");
        link.href = url;
        link.target = "_blank";
        link.setAttribute("download", `${transferReport.Task_ID}-Transfer.pdf`);
        link.click();
      } catch (error) {
        if (error?.response?.status === 424)
          NotificationManager.error(
            "Transfer Task Not Completed, No Report Available"
          );
        else NotificationManager.error("An Error Occured");
      }
    }
    handleLoading(dispatchLoading, false);
  };

  return (
    <div className="violation">
      <h4>Handover Report</h4>
      <div className="select">
        <Form.Label>Type</Form.Label>
        <Form.Select defaultValue="" {...register("Type")}>
          {/* <option value="">All</option> */}
          {transferReportDomains &&
            transferReportDomains?.Type?.map((item) => (
              <option key={item.code} value={item.code}>
                {item.name}
              </option>
            ))}
        </Form.Select>
      </div>
      {transferReportList?.length ? (
        transferReportList.map((report) => (
          <TransferTaskCard
            itemId={report.Task_ID}
            itemIdText="Report ID"
            date={report.Request_Date_ISO}
            item={report}
            key={report.Task_ID}
            hasReports
            reportsFunction={handleReports}
          />
        ))
      ) : (
        <div className="text-center">No Results Found</div>
      )}
    </div>
  );
}
